@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:root {
  --chat-width: 330px;
}

.chatAsideSpacer {
  width: 0;
  z-index: 1;

  [data-autopilot-system-redesign='on'] & {
    z-index: 10;
    background: transparent;
  }

  &.open {
    width: var(--chat-width);
  }
}

.chatAside {
  display: flex;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 0;
  top: 0px;
  bottom: 0;
  flex-direction: column;

  .open & {
    width: var(--chat-width);
  }
}

.root {
  @include container-shadow;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--light-80);

  [data-autopilot-system-redesign='on'] & {
    background: transparent;
    box-shadow: none;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 52px;
  min-height: 52px;
  padding: 0 9px 0 20px;

  &.scrolled {
    @include container-shadow;
  }

  .title {
    display: flex;
    align-items: center;
    gap: 5px;

    .betaPill {
      @include xs-sohne-medium;
    }
  }

  .actions {
    display: flex;
    align-items: center;
  }
}

.loadingHeader {
  width: 100%;
}

.chatContainer {
  @include hide-scrollbar;
  flex: 1;
  overflow-y: scroll;

  [data-autopilot-system-redesign='on'] & {
    border-right: 1px solid var(--dark-4);
    background: #f4f5f5;
  }
}
